import { createLogger } from '@svenskaspelab/nova-core/log';

import type { Product } from '../../../@types/Product.js';
import { type PaymentInfoType } from '../../../payment/createPaymentInfo.js';
import type { Wager } from '../../../wager/Wager.js';

// TODO: this should be improved when we add more products
const tipsenProducts = new Set<Product>(['Powerplay']);

/**
 * Function to url for mybets.
 *
 * @param paidProducts Products that are paid.
 * @returns The url for mybets.
 */
export function getMybetsUrl(paidProducts: Product[]): string {
  // const isTipsenProduct = isTipsetProduct(productIds[0]);
  const [product] = paidProducts;
  const isTipsenProduct = product && tipsenProducts.has(product);

  const returnUrl = isTipsenProduct && paidProducts.length <= 2 ? `${paidProducts[0]}MyBetsHome` : 'myBetsHome';
  // only redirect to product mybets when less than 2 products. If more than 2 products we know its pix-mix and should redirect to global my games
  // return urlMapping.get(returnUrl);
  return returnUrl;
}

/**
 * Function to get products string.
 *
 * @param paymentInfo The payment info for transaction.
 * @param wagers The wagers in transaction.
 * @returns String with products.
 */
export function getProductsString(paymentInfo: PaymentInfoType, wagers?: readonly Wager[]): string {
  // const competitionWager = wagers.find((wager) => wager.isCompetition());
  // let compDesc;
  // if (competitionWager) {
  //   const paymentInfoData = paymentInfo.get();
  //   const postPaymentInfo = paymentInfoData.filter((info) => (info.type === paymentInfoType.POST && info.localId === competitionWager.localId))?.pop();
  //   compDesc = postPaymentInfo.extraData.compName;
  // }
  const paidProducts = [
    ...new Set(wagers?.reduce<string[]>((products, wager) => [...products, ...wager.getProductsInBet()], [])),
  ];
  // .reduce((products, wager) => products.concat((wager === competitionWager && compDesc) ? compDesc : wager.getProductsInBet()), []))];

  if (paidProducts.length === 1) {
    return paidProducts.join('');
  }

  return `${paidProducts.slice(0, -1).join(', ')} och ${paidProducts.at(-1)}`;
}

/**
 * Function to handle numerous words.
 *
 * @param total The total number of items.
 * @returns The function to handle numerous words.
 */
export function numerous(total: number) {
  return (...dictionary: string[][]) =>
    (stringLiteral: string): string => {
      const wordToSelect = total > 1 ? 1 : 0;
      const wordList = dictionary.map((words) => words[wordToSelect]);

      return stringLiteral.replaceAll(/{#(\d)}/g, (match, index: number) => wordList[index] ?? '');
    };
}

const logger = createLogger('payment-sport:utils');

/** Verticals supported by caretech-api. */
export const ALLOWED_CARETECH_VERTICALS = ['casino', 'bingo', 'poker', 'sportsbook', 'pools'] as const;
export type CaretechVertical = (typeof ALLOWED_CARETECH_VERTICALS)[number];

export type LongSessionRestriction = {
  title: string;
  message: string;
};

/**
 * Check if the user has an active long-session restriction via the caretech BFF.
 *
 * @param vertical The gaming vertical to check the restriction for.
 * @returns The restriction details if active, `undefined` otherwise.
 */
export async function hasLongSessionRestriction(
  vertical: CaretechVertical
): Promise<LongSessionRestriction | undefined> {
  try {
    const res = await fetch(`/caretech-api/long-session/check?vertical=${vertical}`);

    if (!res.ok) {
      logger.warn('Failed to check long-session restriction', { status: res.status });
      return undefined;
    }

    const data: unknown = await res.json();

    if (data && typeof data === 'object' && 'title' in data && 'message' in data) {
      return data as LongSessionRestriction;
    }

    return undefined;
  } catch (error) {
    logger.warn('Error checking long-session restriction', { error: String(error) });
    return undefined;
  }
}
